import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas } from '../../styles';

export const GamePreviewContainer = styled.div`
    grid-area: ${GameCenterComponentGridAreas.gamePreview};

    ${BaseStyle.Mixins.screenSizes.large} {
        padding: 0 24px;
    }
`;

export const Title = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle1};
    padding-bottom: 13px;
`;

export const PreviewContainer = styled.a`
    display: flex;
    gap: 18px;
`;

export const PreviewImage = styled.img`
    height: 80px;
    width: 80px;
`;

export const InfoContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    flex-direction: column;
`;

export const Description = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['16b']}
`;

export const Date = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14b']}
    color: ${({ theme }) => theme.Text.secondary};
`;
